import { render, staticRenderFns } from "./BankSyncLoader.vue?vue&type=template&id=4ade8467&scoped=true"
import script from "./BankSyncLoader.vue?vue&type=script&lang=js"
export * from "./BankSyncLoader.vue?vue&type=script&lang=js"
import style0 from "./BankSyncLoader.vue?vue&type=style&index=0&id=4ade8467&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ade8467",
  null
  
)

export default component.exports